export default "__VITE_ASSET__mkNkMobp__"